module.exports = __webpack_public_path__ + "static/img/macLogo.79d3f666.png";